module.exports = __webpack_public_path__ + "static/index/img/baikal-213.96976d67.jpg";